/* assets/ebike-class-finder.js
   E-bike class finder quiz.
   All six questions start unanswered; the result panel reveals once every
   question has an answer and re-computes on every change. */
(function () {
  "use strict";

  var QUESTIONS = ["whereRide", "hills", "throttle", "cargo", "speed", "under16"];

  var LABELS = {
    whereRide: {
      paths: "Shared paths and greenways",
      streets: "City streets and bike lanes",
      mixed: "A mix of paths and streets",
      private: "Off-road or private land"
    },
    hills: {
      flat: "Mostly flat",
      hilly: "Hilly or steep"
    }
  };

  var CLASS_META = {
    "Class 1": { tone: "is-tone-class-1", tag: "Path-first pick", headline: "Cleanest access on shared paths" },
    "Class 2": { tone: "is-tone-class-2", tag: "Versatile fit", headline: "Most versatile public-road fit" },
    "Class 3": { tone: "is-tone-class-3", tag: "Speed-first pick", headline: "Built for faster road commutes" }
  };

  function getChecked(form, name) {
    var el = form.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : null;
  }

  function readAnswers(form) {
    var data = {};
    var answered = 0;
    QUESTIONS.forEach(function (name) {
      data[name] = getChecked(form, name);
      if (data[name] !== null) answered += 1;
    });
    data.answered = answered;
    data.complete = answered === QUESTIONS.length;
    return data;
  }

  function recommend(d) {
    var cls = "Class 2";
    var why = "";
    var bullets = [];

    if (d.under16 === "yes") {
      cls = "Class 1";
      why = "Most states limit throttle use and Class 3 speeds for riders under 16, so Class 1 pedal-assist is the clearest legal starting point at any answer combination.";
      bullets.push("Check your state's minimum age and helmet rules before buying.");
      bullets.push("Some states allow Class 2 for younger riders. Your state page has the exact rule.");
      return { cls: cls, why: why, bullets: bullets, headline: "The clearest starting point for younger riders", tag: "Age-aware pick" };
    }

    if (d.whereRide === "private") {
      cls = "Class 2";
      why = "Class limits mainly govern public roads, paths, and trails. On private land you choose the setup, and a throttle makes technical terrain and restarts easier.";
      bullets.push("Confirm rules before connecting routes through public roads or trails.");
      bullets.push("Ariel Rider street-legal models ship as Class 2; performance models are built for off-road riding on private property.");
      return { cls: cls, why: why, bullets: bullets, headline: "Off-road riding gives you the most freedom", tag: "Off-road pick" };
    }

    if (d.whereRide === "paths") {
      if (d.throttle === "no") {
        cls = "Class 1";
        why = "Class 1 pedal-assist is the most widely accepted setup on shared paths and multi-use trails, and you said you do not need a throttle.";
        bullets.push("Accepted on more paths and trail systems than any other class.");
        if (d.hills === "hilly") {
          bullets.push("Pedal-assist still climbs well. Higher assist levels cover steep sections.");
        }
      } else {
        cls = "Class 2";
        why = "You want a throttle, and Class 2 keeps it inside the 20 mph limit that most shared-path rules are built around.";
        bullets.push("Some paths and trails restrict throttle use. Check the systems you ride most.");
        if (d.hills === "hilly") {
          bullets.push("The throttle earns its keep on steep starts.");
        }
      }
    } else if (d.whereRide === "streets") {
      if (d.speed === "28") {
        cls = "Class 3";
        why = "A 28 mph assisted top speed keeps you closer to city traffic speeds, and Class 3 is the class built for that.";
        bullets.push("Class 3 often carries extra helmet, age, or path restrictions. Check your state page.");
        if (d.throttle === "yes") {
          bullets.push("Class 3 is pedal-assist only in most states. If the throttle is a must-have, Class 2 is the cleaner pick.");
        }
      } else if (d.throttle === "yes") {
        cls = "Class 2";
        why = "For stop-and-go street riding at 20 mph, the Class 2 throttle takes the work out of every light and stop sign.";
        bullets.push("Bike-lane rules for Class 2 are relaxed in most states, but cities can differ.");
      } else {
        cls = "Class 1";
        why = "Pedal-assist at 20 mph handles bike lanes fine, keeps the natural cycling feel you want, and faces the fewest access questions.";
        bullets.push("If traffic speeds feel too quick later, Class 3 is the usual upgrade path.");
      }
    } else {
      if (d.throttle === "yes") {
        cls = "Class 2";
        why = "Your routes change, so the most versatile setup wins: 20 mph with a throttle stays legal in the widest range of places.";
        bullets.push("On path days, ride assist-first where throttles are restricted.");
      } else if (d.speed === "28") {
        cls = "Class 3";
        why = "You favor speed over a throttle, so Class 3 fits the street part of your riding. Plan on slowing down for shared paths.";
        bullets.push("Many paths cap legal assist at 20 mph. Check before taking the fast setup there.");
      } else {
        cls = "Class 1";
        why = "Pedal-assist at 20 mph is the setup that stays welcome across the most route types, which suits mixed riding.";
        bullets.push("Easy to live with: fewest access questions on paths and trails.");
      }
    }

    if (d.cargo === "yes") {
      if (cls === "Class 1") {
        bullets.push("Loaded starts are easier with a throttle. If starts feel hard with cargo, Class 2 is the natural step up.");
      } else if (cls === "Class 2") {
        bullets.push("Throttle starts shine when the bike is loaded.");
      } else {
        bullets.push("With regular cargo, test how the bike starts on hills. A throttle-equipped Class 2 setup can be easier.");
      }
    }

    if (d.hills === "hilly" && bullets.length < 3 && cls !== "Class 1") {
      bullets.push("For steep areas, motor torque matters more than the class label. Compare torque specs, not just top speed.");
    }

    var meta = CLASS_META[cls];
    return { cls: cls, why: why, bullets: bullets, headline: meta.headline, tag: meta.tag };
  }

  function setupLabel(d) {
    var throttlePart = d.throttle === "yes" ? "Throttle" : "Pedal-assist";
    var speedPart = d.speed === "28" ? "up to 28 mph" : "up to 20 mph";
    return throttlePart + " + " + speedPart;
  }

  function riderLabel(d) {
    var parts = [];
    parts.push(d.cargo === "yes" ? "Carries cargo or a passenger" : "Solo rider");
    if (d.under16 === "yes") parts.push("under 16");
    return parts.join(", ");
  }

  function initFinder(container) {
    var form = container.querySelector("[data-finder-form]");
    var result = container.querySelector("[data-finder-result]");
    if (!form || !result) return;

    var els = {
      progress: form.querySelector("[data-finder-progress]"),
      cls: result.querySelector("[data-rec-class]"),
      headline: result.querySelector("[data-rec-headline]"),
      tag: result.querySelector("[data-rec-tag]"),
      why: result.querySelector("[data-rec-why]"),
      list: result.querySelector("[data-rec-list]"),
      live: result.querySelector("[data-rec-live]"),
      route: result.querySelector("[data-rec-route]"),
      terrain: result.querySelector("[data-rec-terrain]"),
      setup: result.querySelector("[data-rec-setup]"),
      useCase: result.querySelector("[data-rec-use-case]"),
      warning: result.querySelector("[data-under16-warning]"),
      card: result.querySelector("[data-rec-card]")
    };
    var chips = result.querySelectorAll("[data-class-chip]");
    var TONES = ["is-tone-class-1", "is-tone-class-2", "is-tone-class-3"];

    function setText(el, txt) {
      if (el) el.textContent = txt;
    }

    function setTone(tone) {
      TONES.forEach(function (t) {
        result.classList.remove(t);
        if (els.card) els.card.classList.remove(t);
      });
      if (tone) {
        result.classList.add(tone);
        if (els.card) els.card.classList.add(tone);
      }
    }

    function setBullets(items) {
      if (!els.list) return;
      els.list.innerHTML = "";
      items.forEach(function (txt) {
        var li = document.createElement("li");
        li.textContent = txt;
        els.list.appendChild(li);
      });
    }

    function renderWaiting(data) {
      result.classList.add("is-waiting");
      setTone(null);
      var remaining = QUESTIONS.length - data.answered;
      setText(els.cls, "Your starting class");
      setText(els.headline, remaining === QUESTIONS.length
        ? "Answer the six questions and it shows up here."
        : remaining + (remaining === 1 ? " answer" : " answers") + " to go.");
      setText(els.tag, "Waiting for answers");
      setText(els.why, "Your answers shape this explanation.");
      setBullets(["Local rules for the paths and trails you actually ride."]);
      setText(els.route, data.whereRide ? LABELS.whereRide[data.whereRide] : "Not answered yet");
      setText(els.terrain, data.hills ? LABELS.hills[data.hills] : "Not answered yet");
      setText(els.setup, data.throttle && data.speed ? setupLabel(data) : "Not answered yet");
      setText(els.useCase, data.cargo ? riderLabel(data) : "Not answered yet");
      if (els.warning) els.warning.hidden = true;
      chips.forEach(function (chip) { chip.classList.remove("is-active"); });
      if (els.live) {
        els.live.textContent = "Answer the six questions to see your recommended starting class. " + data.answered + " of " + QUESTIONS.length + " answered.";
      }
    }

    function renderResult(data) {
      var rec = recommend(data);
      result.classList.remove("is-waiting");
      setTone(CLASS_META[rec.cls].tone);
      setText(els.cls, rec.cls);
      setText(els.headline, rec.headline);
      setText(els.tag, rec.tag);
      setText(els.why, rec.why);
      setBullets(rec.bullets);
      setText(els.route, LABELS.whereRide[data.whereRide]);
      setText(els.terrain, LABELS.hills[data.hills]);
      setText(els.setup, setupLabel(data));
      setText(els.useCase, riderLabel(data));
      if (els.warning) els.warning.hidden = data.under16 !== "yes";
      chips.forEach(function (chip) {
        chip.classList.toggle("is-active", chip.getAttribute("data-class-chip") === rec.cls);
      });
      if (els.live) {
        els.live.textContent = "Recommended starting class: " + rec.cls + ". " + rec.headline + ".";
      }
    }

    function update() {
      var data = readAnswers(form);
      setText(els.progress, data.answered + " of " + QUESTIONS.length + " answered");
      if (data.complete) {
        renderResult(data);
      } else {
        renderWaiting(data);
      }
      return data;
    }

    form.addEventListener("change", function () {
      form.querySelectorAll(".is-missing").forEach(function (q) {
        if (q.querySelector("input:checked")) q.classList.remove("is-missing");
      });
      update();
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var data = update();
      if (data.complete) {
        result.scrollIntoView({ behavior: "smooth", block: "start" });
        if (els.cls) els.cls.focus({ preventScroll: true });
        return;
      }
      var firstMissing = null;
      QUESTIONS.forEach(function (name) {
        if (data[name] !== null) return;
        var input = form.querySelector('input[name="' + name + '"]');
        var fieldset = input ? input.closest("[data-finder-question]") : null;
        if (fieldset) {
          fieldset.classList.add("is-missing");
          if (!firstMissing) firstMissing = fieldset;
        }
      });
      var remaining = QUESTIONS.length - data.answered;
      setText(els.progress, remaining + (remaining === 1 ? " question" : " questions") + " left to answer");
      if (firstMissing) {
        firstMissing.scrollIntoView({ behavior: "smooth", block: "center" });
        var firstInput = firstMissing.querySelector("input");
        if (firstInput) firstInput.focus({ preventScroll: true });
      }
    });

    var resetBtn = form.querySelector("[data-finder-reset]");
    if (resetBtn) {
      resetBtn.addEventListener("click", function () {
        form.reset();
        form.querySelectorAll(".is-missing").forEach(function (q) {
          q.classList.remove("is-missing");
        });
        update();
      });
    }

    update();
  }

  function boot() {
    document.querySelectorAll(".ebike-class-finder").forEach(initFinder);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
